import Packages from "./Packages";
import classes from "./Packages.module.scss"

const PackagesPage = () => {
    return (
        <>
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`} style={{height:"100vh", maxHeight:"none"}}>
            <Packages/>
        </div>
        </>
    )
}

export default PackagesPage;